export enum AssigningRoundEnum {
	None = 0,
	First = 1,
	Second = 2,
	Third = 3
}

